import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => ({
  root: {
    position: 'absolute',
    bottom: '65px',
    right: '15px',
    zIndex: '1500',
  },
  error: {
    backgroundColor: 'var(--mistake-color)',
    width: '260px',
    borderRadius: '5px',
    boxShadow: '0 4px 15px 0 rgba(128,128,128,0.5)',
    marginTop: '15px',
    padding: '11.5px 0 10.5px 5px',
  },
  success: {
    backgroundColor: 'var(--bergamot-color)',
    width: '260px',
    borderRadius: '5px',
    boxShadow: '0 4px 15px 0 rgba(128,128,128,0.5)',
    marginTop: '15px',
    padding: '11.5px 0 10.5px 5px',
  },
  info: {
    backgroundColor: 'var(--ocean-color)',
    width: '260px',
    borderRadius: '5px',
    boxShadow: '0 4px 15px 0 rgba(128,128,128,0.5)',
    marginTop: '15px',
    padding: '11.5px 0 10.5px 5px',
  },
  messageTitle: {
    color: 'var(--gray-100-color)',
    fontSize: '14px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    lineHeight: '18px',
  },
  messageBody: {
    color: 'var(--gray-100-color)',
    fontSize: '14px',
    letterSpacing: '0.5px',
    lineHeight: '18px',
    wordWrap: 'break-word',
  },
  messageIcon: {
    position: 'absolute',
    top: '50%',
    transform: 'translate(0, -50%)',
    paddingLeft: '15px',
    paddingRight: '15px',
    fill: 'var(--gray-100-color)',
    height: '20px',
  },
  message: {
    position: 'relative',
  },
  messageText: {
    marginLeft: '50px',
    paddingRight: '15px',
  },
}));
